import { loadersCommonProps } from '../../config';

const props = {
  ...loadersCommonProps,

  /**
   * Wether the loader is visible or not.
   */
  active: {
    type: Boolean,
    default: true,
  },

  /**
   * Wether the loader spinner animation is on or off.
   */
  paused: {
    type: Boolean,
    default: false,
  },
};

export const muiLoader = {
  props,
};
